/**
 * Sistema de rareza para los stickers Panini WC 2026.
 * Los bordes parallels van de común (white) a más rara (black).
 */

export type RarityTag = 'white' | 'orange' | 'blue' | 'red' | 'purple' | 'green' | 'black';

export type RarityTier = {
  id: RarityTag;
  label: string;
  /** Color de fondo del chip */
  bg: string;
  /** Color del borde del chip */
  border: string;
  /** Glow opcional (para llamar la atención sobre las raras) */
  glow?: string;
  /** Valor relativo para ordenar/matching (1 = más común, 7 = más rara) */
  rank: number;
  /** Descripción breve */
  tooltip: string;
};

export const RARITY_TIERS: RarityTier[] = [
  { id: 'white',  label: 'White',  bg: '#F4F1FF', border: '#D4D4D4', rank: 1, tooltip: 'Common (base)' },
  { id: 'orange', label: 'Orange', bg: '#FF8C42', border: '#FF8C42', rank: 2, tooltip: 'Uncommon' },
  { id: 'blue',   label: 'Blue',   bg: '#5EE0FF', border: '#5EE0FF', rank: 3, tooltip: 'Rare' },
  { id: 'red',    label: 'Red',    bg: '#E60012', border: '#E60012', rank: 4, tooltip: 'Rarer' },
  { id: 'purple', label: 'Purple', bg: '#A855F7', border: '#A855F7', rank: 5, glow: '0 0 12px rgba(168,85,247,0.6)', tooltip: 'Super rare' },
  { id: 'green',  label: 'Green',  bg: '#C6FF5E', border: '#C6FF5E', rank: 6, glow: '0 0 14px rgba(198,255,94,0.7)', tooltip: 'Ultra rare (1:1400 packs)' },
  { id: 'black',  label: 'Black',  bg: '#1A1A1A', border: '#888888', rank: 7, glow: '0 0 14px rgba(0,0,0,0.6)', tooltip: 'Rarest' },
];

export function getRarityTier(tag?: string | null): RarityTier | null {
  if (!tag) return null;
  return RARITY_TIERS.find((r) => r.id === tag) ?? null;
}
